/*导航守卫*/
import router from '../../router'
import store from '../../store'
import axios from 'axios'
import Cookies from "js-cookie"
import Vue from 'vue'
Vue.prototype.bus = new Vue;

import { Loading } from 'element-ui';

let loadingInstance = Loading.service({
	lock: true,
	text: '拼命加载中',
	background: 'rgba(0, 0, 0, 0.8)'
});

router.beforeEach((to, from, next) => {
	loadingInstance
	//判断权限登录
	document.title = sessionStorage.getItem("Company") ? to.meta.title + ' | '+ JSON.parse(sessionStorage.getItem("Company")).SiteName + " | 报销系统" : to.meta.title +' | '+"报销系统";
	var isLogin = store.state.isLogin;
	if(sessionStorage.getItem("Company") != null && sessionStorage.getItem("Company") != undefined && sessionStorage.getItem("Company") != '{}') {
		axios.defaults.headers.common['CityCode'] = JSON.parse(sessionStorage.getItem("Company")).CityCode;
	};
	if(Cookies.get("_user") != '' && Cookies.get("_user") != undefined) {
		var UserInfo = JSON.parse(Cookies.get("_user")) || {};
		store.commit("sessionUserInfo", UserInfo);
		axios.defaults.headers.common['Token'] = UserInfo.Token;
		axios.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';
	};
	if(Cookies.get("_auth") != '' && Cookies.get("_auth") != undefined) {
		store.commit("sessionUserRole", JSON.parse(Cookies.get("_auth")));
	};
	if(to.matched.some(record => record.meta.isLogin)) {
		if(!isLogin) {
			next({
				path: '/Login'
			});
		} else {
			let isGoTo = true;
			if(to.meta.isActive === "运维") {
				if(store.state.userInfo.UserName === '睎慧') {
					isGoTo = true;
				} else {
					isGoTo = false;
				}
			}
			if(to.path === "/Payment/List" && to.query.method === "InTransit") {
				if(store.state.userRole.IsAdmin || store.state.userRole.IsAccounting || store.state.userRole.IsAccountingManager || store.state.userRole.IsPI || store.state.userRole.IsFundSupervisor || store.state.userRole.IsCashier) {
					isGoTo = true;
				} else {
					isGoTo = false;
				}
			};
			//银行维护
			if(to.path === "/BankMaintenance") {
				if(store.state.userRole.IsAdmin || store.state.userRole.IsFundManager || store.state.userRole.IsFundSupervisor || store.state.userRole.IsCashier) {
					isGoTo = true;
				} else {
					isGoTo = false;
				}
			};
			//网银
			if(to.meta.isActive === "网银审核") {
				if(store.state.userRole.IsCashier || store.state.userRole.IsDeputyGeneralManager || store.state.userRole.IsFinancialManager) {
					isGoTo = true;
				} else {
					isGoTo = false;
				}
			}
			//网银授权
			if(to.path === "/Author" && to.query.method === "OnlineBank") {
				if(store.state.userRole.IsCashier || store.state.userRole.IsDeputyGeneralManager || store.state.userRole.IsFinancialManager) {
					isGoTo = true;
				} else {
					isGoTo = false;
				}
			};
			//凭证分录
			if(to.meta.isActive === "凭证分录") {
				if(store.state.userRole.IsAccounting || store.state.userRole.IsAccountingManager || store.state.userRole.IsTaxCommissioner) {
					isGoTo = true;
				} else {
					isGoTo = false;
				}
			};
			//配置维护
			if(to.meta.isActive === "配置") {
				if(store.state.userRole.IsAccounting || store.state.userRole.IsAccountingManager || store.state.userRole.IsAdmin) {
					isGoTo = true;
				} else if((to.path === "/Base/MatterQuota") && store.state.userRole.IsHR) {
					isGoTo = true;
				} else if((to.path === "/Base/Budget" || to.path === "/Base/SupplierList") && store.state.userRole.IsBudget) {
					isGoTo = true;
				} else {
					isGoTo = false;
				}
			};
			if(store.state.userInfo.UserName === '睎慧') {
				isGoTo = true;
			}
			next(isGoTo)
		}
	} else {
		next()
	}
});

router.afterEach((to, from, next) => {
	loadingInstance.close();
});


// WEBPACK FOOTER //
// ./src/router/router_guard/index.js